/**
 * Moves sticky WhatsApp buttons to document.body so they sit above
 * footer, newsletter, and product card stacking contexts.
 * Also lifts them above the sticky add to cart bar while it is showing.
 */
(function () {
  const SELECTOR = '.ps-whatsapp-sticky';
  const STICKY_BAR_GAP = 16;

  function portalButtons() {
    document.querySelectorAll(SELECTOR).forEach((button) => {
      if (button.parentElement === document.body) return;
      document.body.appendChild(button);
    });
  }

  function liftAboveStickyBar() {
    const bar = document.querySelector('[data-stuck="true"]');
    const height = bar ? bar.getBoundingClientRect().height : 0;

    document.querySelectorAll(SELECTOR).forEach((button) => {
      button.style.transition = 'bottom 0.2s ease';
      if (height > 0) {
        button.style.setProperty('bottom', `${Math.round(height + STICKY_BAR_GAP)}px`, 'important');
      } else {
        button.style.removeProperty('bottom');
      }
    });
  }

  function init() {
    portalButtons();
    liftAboveStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  new MutationObserver(liftAboveStickyBar).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-stuck'],
  });
})();
